import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/revenue-lockdowns/new/loading';

export const Route = createFileRoute('/_private/settings/revenue-lockdowns/new')({
  pendingComponent: Loading,
});
